import { Link } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { CollectShareSection } from "./CollectShareSection";
import { SubmissionReview } from "./SubmissionReview";

/**
 * Collect Contacts page (/app/contacts/collect). Two halves: share a link for
 * people to enter their own details, then review what comes in before it's
 * added to the contact list.
 */
export function CollectContacts() {
  return (
    <Section spacing="md">
      <Container size="4xl">
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-2">
            <Link
              to="/app/contacts"
              className="type-label-sm tracking-wider uppercase text-text-muted hover:text-text"
            >
              ← Back to contacts
            </Link>
            <h1 className="type-heading-lg text-text">Collect contacts</h1>
            <p className="type-body-sm text-text-muted">
              Publish a page so people can fill in their own details. Submissions wait for your
              review — add them as new contacts, merge into existing ones, or delete them.
            </p>
          </div>

          <CollectShareSection />
          <SubmissionReview />
        </div>
      </Container>
    </Section>
  );
}
